import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_northtrader.png",
      alt: "Estratégias North Trader",
    },
    title: "Opere Análise de Fluxo com a North Trader",

    // String ou array de strings
    text: "As entradas são executadas a partir de um algoritmo de leitura de fluxo (Tape Reading). Realizando a análise do Times & Trades das ações para identificar os pontos de maior interesse para os traders, e se posicionando a favor deles no mini indice. Assim, o algoritmo pode realizar diversas operações durante o dia com um risco muito baixo e utilizar da força de interesse dos grandes Players.",
    testimonial: {
      text: ["Os nossos robôs, as suas ordens."],
      author: {
        name: "Henrique L. Head da North Trader",
        // picture: 'https://ontick-img.s3.sa-east-1.amazonaws.com/raphael_qgdotrader_profile.png',
      },
    },
  },

  strategies: {
    title: "North Trader",
    heading: "Opere uma estratégia focada em análise de fluxo no estilo Scalp.",
    subtitle: [
      "Estratégia desenvolvida por profissionais, onde alinha análise de fluxo, técnica, velocidade e precisão na execução de suas estratégias.",
    ],
  },

  cta: {
    title: "A tecnologia está mudando o futuro do mercado financeiro! ",
    subtitle: "Venha fazer parte dessa mudança com a gente! ",
  },

  about: {
    title: "Sobre a empresa",
    subtitle: "A North Trader",
    col1: [
      "A North Trader é especializada no desenvolvimento de robôs com análise de fluxo e expert na criação de estratégias automatizadas com Walk Forward Analysis conforme mudanças de ciclo do mercado econômico usando uma abordagem científica para desenvolvimento de suas estratégias.",
    ],
    col2: [
      "Focada em tecnologia, utiliza algoritmos para leitura do Times & Trades garantindo um stop curto e uma entrada precisa na execução de seus trades.",
    ],
  },

  stats: {
    title: "Alguns números da North Trader",
    subtitle: "Análise do Fluxo das ações + Análise Técnica do Ibovespa =",
    data: [
      {
        value: "+200%",
        description: "Retorno anualizado",
      },
      {
        value: "+1,4",
        description: "Fator de lucro",
      },
      {
        value: "+1K",
        description: "Clientes satisfeitos",
      },
    ],
  },

  features: {
    type: 1,
    title: "Por quê utilizar a North Trader?",
    subtitle: "Veja quais as principais vantagens em escolher os nossos robôs.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "30 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      {
        icon: iconsSet.lightning,
        title: "Velocidade",
        description:
          "Os nossos algoritmos conseguem realizar milhares de cáculos por segundo e tomam decisões muito mais rápido do que qualquer ser humano.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe tempo",
        description:
          "Você não precisa ficar na frente no computador para realizar suas operações. Escolha suas estratégias e deixe que a plataforma opere por você.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem emocional",
        description:
          "Muitas vezes agimos de maneira irracional e impulsiva em nossos investimentos. Com as estratégias automatizadas você não terá esse problema!",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Nunca havia ficado positivo no Day Trade, mas no primeiro mês usando a estratégia eu consegui ficar positivo e pagar a DARF no final do mês. Parabéns a toda equipe da North Trader.",
      author: "Jonathan",
      job: "Analista de Sistema",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "Além das estratégias com um ótimo operacional, possuem um excelente atendimento. Muita transparência para os clientes!",
      author: "José Carlos",
      job: "Empresário",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
